import React from 'react';
const ApartmentsIcon: React.FC<{ size?: number; color?: string }> = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 8.5L10 2L18 8.5" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="4" y="8.5" width="12" height="9.5" rx="1" stroke={color} strokeWidth="1.7" />
    <rect x="6" y="11" width="3" height="3" rx="0.5" stroke={color} strokeWidth="1.4" />
    <rect x="11" y="11" width="3" height="3" rx="0.5" stroke={color} strokeWidth="1.4" />
    <rect x="8.5" y="14.5" width="3" height="3.5" rx="0.5" stroke={color} strokeWidth="1.4" />
  </svg>
);
export default ApartmentsIcon;
